export class Price {
    static format(value) {
        return 'CHF ' + Math.floor(parseFloat(value.toString()));
    }
    static round(value) {
        return (Math.ceil(value * 20 - 0.5) / 20).toFixed(2);
    }
    static addCents(value) {
        return (Price.isInteger(value)) ? parseInt(value) + '.<span class="cents">–</span>' : value;
    }
    static isInteger(value) {
        return parseFloat(value) % 1 === 0;
    }
}
